import _merge from 'lodash/merge'
import _has from 'lodash/has'
import _pickBy from 'lodash/pickBy'

const defaultFilterOptions = (_this, fliterOptions) => {
  const hasDefaultColDefTooltip = _has(
    fliterOptions,
    'defaultColDef.tooltipComponent',
  )
  const hasRowSelection = _has(fliterOptions, 'rowSelection')
  const hasSuppressRowClickSelection = _has(
    fliterOptions,
    'suppressRowClickSelection',
  )
  const hasContextMenu = _has(fliterOptions, 'getContextMenuItems')
  const hasGridFilters = 'gridFilters' in _this
  const hasPageSize = 'pageSize' in _this

  return {
    defaultColDef: {
      floatingFilter: hasGridFilters ? _this.gridFilters : true,
      headerClass: 'ag-grid--sort-column',
      menuTabs: [],
      minWidth: 105,
      resizable: true,
      sortable: true,
      tooltipValueGetter: hasDefaultColDefTooltip
        ? toolTipValueGetter
        : undefined,
    },
    floatingFiltersHeight: 40,
    headerHeight: 40,
    icons: {
      sortAscending:
        '<span class="mdi-icon"><i class="icon mdi mdi-arrow-up"/></span>',
      sortDescending:
        '<span class="mdi-icon"><i class="icon mdi mdi-arrow-down"/></span>',
    },
    rowHeight: 40,
    tooltipShowDelay: hasDefaultColDefTooltip ? 0 : undefined,
    localeText: { noRowsToShow: 'No Data Displayed' },
    pagination: true,
    paginationPageSize: hasPageSize ? _this.pageSize : 25,
    rowBuffer: hasPageSize ? _this.pageSize : undefined,
    suppressCellFocus: true,
    suppressContextMenu: !hasContextMenu,
    suppressPaginationPanel: true,
    suppressRowClickSelection: !hasRowSelection,
    rowSelection: hasRowSelection ? fliterOptions.rowSelection : undefined,
    rowClass:
      hasRowSelection && !hasSuppressRowClickSelection
        ? ['ag-row--drill-accent', 'ag-row--drill-ripple']
        : undefined,
    animateRows: true,
  }
}

const calculateTextWidth = (text, font) => {
  const canvas = document.createElement('canvas')
  const context = canvas.getContext('2d')
  context.font = font || '12px Sans-Serif'
  return Math.ceil(context.measureText(text).width) + 32
}

const toolTipValueGetter = param => {
  if (param.value) {
    let text = param.value
    const hasValueFormatter = _has(param, 'colDef.valueFormatter')
    if (hasValueFormatter) {
      const formater = param.colDef.valueFormatter
      text = formater(param)
    }

    const textWidth = calculateTextWidth(text)
    return textWidth > param.column.actualWidth ? text : null
  }
  return null
}

const getFilterOptions = (_this, fliterOptions = {}) => {
  const mergedOptions = _merge(
    {},
    defaultFilterOptions(_this, fliterOptions),
    fliterOptions,
  )

  const cleanFliterOptions = _pickBy(mergedOptions, function (value) {
    return !(value === undefined)
  })

  return cleanFliterOptions
}

export { getFilterOptions }
